import React, { CSSProperties } from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import styles from "./papperStyle-jss";
import FilterList from "@material-ui/icons/FilterList";
import { Fab } from "@material-ui/core";
import { getTitulo } from "../../utils/routes";

interface Props {
  classes: any;
  title: String;
  desc?: string;
  openFilter?: () => void;
  icon?: String;
  children: React.ReactNode;
  whiteBg?: Boolean;
  whiteBgNormal?: Boolean;
  colorMode?: Boolean;
  noMargin?: Boolean;
  overflowX?: Boolean;
  isTableMobile?: boolean;
  stylesDesc?: CSSProperties;
  marginRight?: number;
  minHeight?: number;
  centerTitle?: boolean;
  plain?: boolean;
  preencheAltura?: boolean;
}

// O nome da tela ja e exibido pelo layout (faixa de titulo + breadcrumb). Quando o card
// repete esse mesmo nome, o titulo interno e suprimido para o nome ficar so na parte de fora.
const repeteTituloDaPagina = (title: String) => {
  const tituloDaPagina = getTitulo(window.location.pathname);
  if (!tituloDaPagina || !title) {
    return false;
  }
  return String(title).trim().toLowerCase() === tituloDaPagina.trim().toLowerCase();
};

class PapperBlock extends React.Component<Props> {
  render() {
    const {
      classes,
      title,
      desc,
      children,
      whiteBg,
      whiteBgNormal,
      noMargin,
      colorMode,
      overflowX,
      openFilter,
      stylesDesc,
      marginRight,
      minHeight,
      isTableMobile,
      centerTitle,
      plain,
      preencheAltura,
    } = this.props;
    const exibeTitulo = !repeteTituloDaPagina(title);
    const exibeDescBlock = exibeTitulo || !!openFilter || !!desc;
    return (
      <div>
        <Paper
          className={classNames(
            classes.root,
            noMargin && classes.noMargin,
            colorMode && classes.colorMode,
            isTableMobile && classes.tableMobile,
            centerTitle && classes.centerTitle,
            plain && classes.plain,
            preencheAltura && classes.preencheAltura
          )}
          elevation={0}
          style={{ marginRight, transition: "all 0.4s", minHeight }}
        >
          {exibeDescBlock && (
          <div className={classNames(classes.descBlock, openFilter && classes.descBlockComAcoes)} style={stylesDesc}>
            <div className={classes.titleText}>
              {exibeTitulo && (
                <Typography variant="h6" component="h2" className={classes.title}>
                  {title}
                </Typography>
              )}
              <Typography
                component="div"
                className={classes.description}
                dangerouslySetInnerHTML={desc ? { __html: desc } : undefined}
              />
            </div>
            {openFilter && (
              <Fab
                variant="extended"
                size="medium"
                color="primary"
                aria-label="Filtrar"
                className={classes.botaoFiltro}
                onClick={openFilter}
              >
                <FilterList data-testid="icone-filtrar" style={{ marginRight: 7 }} />
                Filtrar
              </Fab>
            )}
          </div>
          )}
          <section
            className={classNames(
              classes.content,
              whiteBg && classes.whiteBg,
              whiteBgNormal && classes.whiteBgNormal,
              overflowX && classes.overflowX,
              isTableMobile && classes.tableMobile
            )}
          >
            {children}
          </section>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles as any)(PapperBlock);
